import axios from 'axios'
import CONFIG from '@/config/config'
const PRE_FIX = CONFIG.API_URL //+ (CONFIG.PROFILE === 'production' ? '/api':'')
import Vue from 'vue'

let checkParams = function(params) {
    let checkObj = $.extend(true,{},params)
    let checkedKeys = Object.keys(checkObj).filter(key => key !== 'page' && !checkObj[key])
    checkedKeys.forEach(function(key) {
        delete checkObj[key]
    })
    return  checkObj
}

export default {
    async getEvents(params) {
        return await axios.get(PRE_FIX + '/v1/ums/event/list',{params: checkParams(params)}).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async getTemplatesInEvents(params) {
        return await axios.get(PRE_FIX + '/v1/ums/event/detail/'+params.eventId).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        })
    },
    async saveEventType(params, file) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/event/save', checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async deleteEvent(eventId) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/event/delete/'+eventId).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async isExistEventId(params) {
        Vue.prototype.$loading(true)
        return await axios.get(PRE_FIX + '/v1/ums/event/list?size=10000').catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async saveTemplate(params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/template/save',checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async deleteTemplateInEvent(tmplId) {
        Vue.prototype.$loading(true)
        return await axios.delete(PRE_FIX + '/v1/ums/template/delete/'+tmplId).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async testMailSend(info,params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v1/ums/send/'+info.clientCd+'/'+info.eventId,checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async testMailSendVer2(info,params) {
        Vue.prototype.$loading(true)
        return await axios.post(PRE_FIX + '/v2/ums/send/'+info.clientCd+'/'+info.eventId,checkParams(params)).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },
    async bulkMessageSend(clientCd,eventId,msgType,lang,file) {
        Vue.prototype.$loading(true)
        let formData = new FormData();
        formData.append('uploadFile', file)
        return await axios.post(PRE_FIX + '/v1/ums/bulksend/'+clientCd+'/'+eventId + '/' + msgType +'/'+lang, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        }).catch(function (err) {
            Vue.prototype.$notify.error('Failed', err)
        }).finally(function () {
            Vue.prototype.$loading(false)
        })
    },

}
